

















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';


@Component({
})
export default class ConfirmationDialog extends Vue {
  @Prop({default: false}) private openDialog!: boolean;

  private showDialog: boolean = false;

  private confirm() {
    this.$emit('confirm');
    this.showDialog = false;
  }

  private close() {
    this.$emit('close');
    this.showDialog = false;
  }

  @Watch('openDialog')
  private onDialogChange(newVal) {
    this.showDialog = newVal;
  }
}
